import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { POSSIBLE_PRICE_TYPE } from '@/store/targetAccumulator/state.ts';

export const PremiumPriceType = () => {
  const premiumPriceType = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.premiumPriceType,
  );
  const premiumTypeCurrencyIndex = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.premiumTypeCurrencyIndex,
  );
  const currencyPair = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.currencyPair);
  const [currency1, currency2] = currencyPair ? currencyPair.split('/') : ['', ''];
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handlePremiumPriceTypeChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      sgwtWebAnalytics?.trackEvent(
        'Target Accumulator',
        'Premium price type changed',
        isDefined(event.target.value) ? event.target.value : 'cleared',
      );

      checkTargetAccumulatorWithTradeCapture({
        premiumPriceType: event.target.value as 'Amount',
      });
    },
    [checkTargetAccumulatorWithTradeCapture, sgwtWebAnalytics],
  );

  const handlePremiumTypeCurrencyChange = useCallback(() => {
    checkTargetAccumulatorWithTradeCapture({
      premiumTypeCurrencyIndex: premiumTypeCurrencyIndex === 1 ? 2 : 1,
    });
  }, [checkTargetAccumulatorWithTradeCapture, premiumTypeCurrencyIndex]);

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.priceType">
      <div className="d-flex">
        <Form.Select
          value={premiumPriceType}
          onChange={handlePremiumPriceTypeChange}
          size="sm"
          data-e2e="price-type-selector"
        >
          {POSSIBLE_PRICE_TYPE.map((priceType) => (
            <option key={priceType} value={priceType}>
              <FormattedMessage id={`targetAccumulator.form.priceType.${priceType}`} />
            </option>
          ))}
        </Form.Select>
        <button
          type="button"
          data-e2e="premium-type-currency"
          onClick={() => {
            handlePremiumTypeCurrencyChange();
          }}
          className={`${premiumTypeCurrencyIndex === 2 ? 'btn-warning' : ''} btn btn-discreet-primary btn-sm`}
        >
          {premiumTypeCurrencyIndex === 1 ? currency1 : currency2}
        </button>
      </div>
    </TargetAccumulatorFormField>
  );
};
